export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/src/number.js
// module id = 795
// module chunks = 0